import React    from 'react';
import Loadable from 'react-loadable';
import {
  Alert,
  Button
}               from 'reactstrap';
import Loading  from '../generic/Loading';

/**
 * Builds a loadable component.
 *
 * @param {function(): Promise}   loader        Callback to import the module asynchronously.  Should use import(), and return it's
 *                               promise.
 * @param {string} [namedExport] Module export to use, if not `default`.
 * @param {int}    [delay]       Number of milliseconds to wait before displaying the loading spinner.
 *                               Default: 200
 *
 * @return {*}
 */
const loadable = ({loader, namedExport = 'default', delay = 200}) => {

  return Loadable({
    loader,
    delay,
    render:  (loaded, props) => {

      const Component = loaded[namedExport];

      return <Component {...props}/>;

    },
    loading: ({error, retry, pastDelay}) => {

      if (error) {

        console.error(error);

        return <Alert color="danger">Unable to load content. <Button onClick={retry}>Retry</Button></Alert>;

      } else if (pastDelay) {

        return <Loading/>;

      }

      return null;

    },
  });

};

export default loadable;


// WEBPACK FOOTER //
// ./src/components/HOC/loadable.js